export const extractDomain = (uri: string): string => {
  return uri
    .replace(/\/$/gi, "")
    .match(
      new RegExp(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+)/, "img"),
    )?.[0] as string;
};

export const isValidUri = (uri: string): boolean =>
  uri.length > 3 && new RegExp(/https?:\/\/(www\.)?/, "gi").test(uri);
